import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/dropdown.tsx
var Dropdown = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M2 6.75H22C22.6904 6.75 23.25 7.30964 23.25 8V16C23.25 16.6904 22.6904 17.25 22 17.25H2C1.30964 17.25 0.75 16.6904 0.75 16V8C0.75 7.30964 1.30964 6.75 2 6.75Z",
		stroke: "currentColor",
		strokeWidth: "1.5"
	}), /* @__PURE__ */ jsx("path", {
		d: "M19 11L17 13L15 11",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})] }) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M2 6.75H22C22.6904 6.75 23.25 7.30964 23.25 8V16C23.25 16.6904 22.6904 17.25 22 17.25H2C1.30964 17.25 0.75 16.6904 0.75 16V8C0.75 7.30964 1.30964 6.75 2 6.75Z",
		stroke: "currentColor",
		strokeWidth: "1.5"
	}), /* @__PURE__ */ jsx("path", {
		d: "M16.9999 13.75C17.1989 13.75 17.3896 13.6709 17.5302 13.5303L19.5302 11.5303C19.8231 11.2374 19.8231 10.7626 19.5302 10.4697C19.2373 10.1768 18.7626 10.1768 18.4697 10.4697L16.9999 11.9395L15.5302 10.4697C15.2373 10.1768 14.7626 10.1768 14.4697 10.4697C14.1768 10.7626 14.1768 11.2374 14.4697 11.5303L16.4697 13.5303L16.5839 13.624C16.7062 13.7056 16.8508 13.75 16.9999 13.75Z",
		fill: "currentColor"
	})] })
});
//#endregion
export { Dropdown };
